import {
  GET_EXPORTED_FILE,
  GET_EXPORTED_FILE_TEMPLATE
} from './constants'

/**
 * Export file
 * @param {string} filename prefix to be matched against
 * @param {int} outletId current outlet id export
 * @param {string} currentPage name of current page that will be displayed when export fails
 * @return {{type, payload: {filename: *, outletId: *, currentPage: *}}}
 */
export function getExportedFile (filename, outletId, currentPage) {
  return {type: GET_EXPORTED_FILE, payload: {filename, outletId, currentPage}}
}

export function getExportedWithoutOutlet (filename) {
  return {type: GET_EXPORTED_FILE_TEMPLATE, payload: {filename}}
}



// WEBPACK FOOTER //
// ./app/actions/get-exported-file/get-exported-file.js